// import React, { useMemo } from "react";
// import {
//   Grid,
//   Card,
//   CardContent,
//   Typography,
//   Stack,
//   Chip,
//   IconButton,
//   Tooltip,
//   TextField,
//   MenuItem,
//   Button,
//   Alert,
// } from "@mui/material";
// import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
// import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
// import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import { TEMPLATE_TYPES, TEMPLATE_STATUS } from "../ClientEmailManager";

// const EmailTemplatesTab = ({
//   templates,
//   templateFilter,
//   setTemplateFilter,
//   onEdit,
//   onDelete,
//   onSend,
// }) => {
//   const filteredTemplates = useMemo(() => {
//     return templates.filter((item) => {
//       const matchesSearch =
//         !templateFilter.search ||
//         item.name?.toLowerCase().includes(templateFilter.search.toLowerCase()) ||
//         item.subject?.toLowerCase().includes(templateFilter.search.toLowerCase());

//       const matchesType =
//         !templateFilter.type || item.template_type === templateFilter.type;

//       const matchesStatus =
//         !templateFilter.status || item.status === templateFilter.status;

//       return matchesSearch && matchesType && matchesStatus;
//     });
//   }, [templates, templateFilter]);

//   const privateTemplates = filteredTemplates.filter((t) => !t.is_global);
//   const globalTemplates = filteredTemplates.filter((t) => t.is_global);

//   const renderCards = (items, isGlobal = false) => {
//     if (items.length === 0) {
//       return (
//         <Grid item xs={12}>
//           <Alert severity="info">
//             No {isGlobal ? "global" : "private"} templates found.
//           </Alert>
//         </Grid>
//       );
//     }

//     return items.map((template) => (
//       <Grid item xs={12} md={6} lg={4} key={template.id}>
//         <Card variant="outlined" sx={{ borderRadius: 3, height: "100%" }}>
//           <CardContent>
//             <Stack spacing={1.5}>
//               <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
//                 <div>
//                   <Typography variant="h6">{template.name}</Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     {template.subject}
//                   </Typography>
//                 </div>

//                 <Chip
//                   label={template.status}
//                   color={
//                     template.status === "active"
//                       ? "success"
//                       : template.status === "draft"
//                       ? "warning"
//                       : "default"
//                   }
//                   size="small"
//                 />
//               </Stack>

//               <Stack direction="row" spacing={1} flexWrap="wrap">
//                 <Chip label={template.template_type} size="small" variant="outlined" />
//                 <Chip
//                   label={isGlobal ? "Global" : "Private"}
//                   size="small"
//                   color={isGlobal ? "secondary" : "primary"}
//                 />
//               </Stack>

//               <Typography variant="body2" color="text.secondary">
//                 {template.preview_text || "No preview text"}
//               </Typography>

//               <Stack direction="row" spacing={1}>
//                 <Tooltip title="Preview">
//                   <IconButton onClick={() => onEdit(template)}>
//                     <VisibilityOutlinedIcon />
//                   </IconButton>
//                 </Tooltip>

//                 {!isGlobal && (
//                   <Tooltip title="Edit">
//                     <IconButton onClick={() => onEdit(template)}>
//                       <EditOutlinedIcon />
//                     </IconButton>
//                   </Tooltip>
//                 )}

//                 <Tooltip title="Send">
//                   <IconButton onClick={() => onSend(template)}>
//                     <SendOutlinedIcon />
//                   </IconButton>
//                 </Tooltip>

//                 {!isGlobal && (
//                   <Tooltip title="Delete">
//                     <IconButton color="error" onClick={() => onDelete(template.id)}>
//                       <DeleteOutlineIcon />
//                     </IconButton>
//                   </Tooltip>
//                 )}
//               </Stack>
//             </Stack>
//           </CardContent>
//         </Card>
//       </Grid>
//     ));
//   };

//   return (
//     <Grid container spacing={2}>
//       <Grid item xs={12}>
//         <Card variant="outlined" sx={{ borderRadius: 3 }}>
//           <CardContent>
//             <Grid container spacing={2}>
//               <Grid item xs={12} md={5}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Search templates"
//                   value={templateFilter.search}
//                   onChange={(e) =>
//                     setTemplateFilter((prev) => ({ ...prev, search: e.target.value }))
//                   }
//                 />
//               </Grid>

//               <Grid item xs={12} md={3}>
//                 <TextField
//                   select
//                   fullWidth
//                   size="small"
//                   label="Type"
//                   value={templateFilter.type}
//                   onChange={(e) =>
//                     setTemplateFilter((prev) => ({ ...prev, type: e.target.value }))
//                   }
//                 >
//                   <MenuItem value="">All</MenuItem>
//                   {TEMPLATE_TYPES.map((type) => (
//                     <MenuItem key={type} value={type}>
//                       {type}
//                     </MenuItem>
//                   ))}
//                 </TextField>
//               </Grid>

//               <Grid item xs={12} md={2}>
//                 <TextField
//                   select
//                   fullWidth
//                   size="small"
//                   label="Status"
//                   value={templateFilter.status}
//                   onChange={(e) =>
//                     setTemplateFilter((prev) => ({ ...prev, status: e.target.value }))
//                   }
//                 >
//                   <MenuItem value="">All</MenuItem>
//                   {TEMPLATE_STATUS.map((status) => (
//                     <MenuItem key={status} value={status}>
//                       {status}
//                     </MenuItem>
//                   ))}
//                 </TextField>
//               </Grid>

//               <Grid item xs={12} md={2}>
//                 <Button
//                   fullWidth
//                   variant="outlined"
//                   onClick={() => setTemplateFilter({ search: "", type: "", status: "" })}
//                 >
//                   Clear
//                 </Button>
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>
//       </Grid>

//       <Grid item xs={12}>
//         <Typography variant="h6" sx={{ mb: 1 }}>
//           Your Templates
//         </Typography>
//       </Grid>

//       {renderCards(privateTemplates, false)}

//       <Grid item xs={12} sx={{ mt: 1 }}>
//         <Typography variant="h6" sx={{ mb: 1 }}>
//           Global Templates
//         </Typography>
//       </Grid>

//       {renderCards(globalTemplates, true)}
//     </Grid>
//   );
// };

// export default EmailTemplatesTab;


import React, { useMemo } from "react";
import {
  Grid, Card, CardContent, Typography, Stack, Chip, IconButton, Tooltip,
  TextField, MenuItem, Button, Alert, Paper, Box, Fade
} from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { TEMPLATE_TYPES, TEMPLATE_STATUS } from "../ClientEmailManager";

const accent = "#0d47a1";
const accentLight = "#e3f2fd";

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px", backgroundColor: "#f8f9fb",
    "&:hover": { backgroundColor: "#f0f2f5" },
    "&.Mui-focused": { backgroundColor: "#fff", "& .MuiOutlinedInput-notchedOutline": { borderColor: accent, borderWidth: 2 } }
  },
  "& .MuiInputLabel-root.Mui-focused": { color: accent }
};

const statusColor = { draft: { bg: "#fff3e0", text: "#e65100" }, active: { bg: "#e8f5e9", text: "#2e7d32" }, archived: { bg: "#f5f5f5", text: "#999" } };

const EmailTemplatesTab = ({ templates, templateFilter, setTemplateFilter, onEdit, onDelete, onSend }) => {
  const filtered = useMemo(() => templates.filter((item) => {
    const s = !templateFilter.search || item.name?.toLowerCase().includes(templateFilter.search.toLowerCase()) || item.subject?.toLowerCase().includes(templateFilter.search.toLowerCase());
    const t = !templateFilter.type || item.template_type === templateFilter.type;
    const st = !templateFilter.status || item.status === templateFilter.status;
    return s && t && st;
  }), [templates, templateFilter]);

  const privateTemplates = filtered.filter((t) => !t.is_global);
  const globalTemplates = filtered.filter((t) => t.is_global);

  const renderCards = (items, isGlobal = false) => {
    if (!items.length) {
      return (
        <Grid item xs={12}>
          <Paper elevation={0} sx={{ p: 4, textAlign: "center", borderRadius: 3, border: "1px dashed #c5cae9" }}>
            <DescriptionOutlinedIcon sx={{ fontSize: 40, color: "#c5cae9", mb: 1 }} />
            <Typography variant="body2" color="text.secondary">No {isGlobal ? "global" : "private"} templates found.</Typography>
          </Paper>
        </Grid>
      );
    }
    return items.map((template) => (
      <Grid item xs={12} sm={6} lg={4} key={template.id}>
        <Fade in timeout={400}>
          <Card elevation={0} sx={{
            borderRadius: 3, border: "1px solid #e3e8f0", height: "100%",
            transition: "all 0.25s", "&:hover": { borderColor: accent, boxShadow: "0 8px 24px rgba(13,71,161,0.1)", transform: "translateY(-2px)" }
          }}>
            <CardContent sx={{ p: 2.5 }}>
              <Stack spacing={1.5}>
                <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography variant="subtitle1" fontWeight={700} noWrap sx={{ color: "#1a1a2e" }}>{template.name}</Typography>
                    <Typography variant="caption" color="text.secondary" noWrap>{template.subject}</Typography>
                  </Box>
                  <Stack direction="row" spacing={0.5}>
                    <Chip size="small" label={template.template_type} sx={{ backgroundColor: accentLight, color: accent, fontWeight: 600, fontSize: 11 }} />
                    <Chip size="small" label={template.status}
                      sx={{ backgroundColor: statusColor[template.status]?.bg || "#f5f5f5", color: statusColor[template.status]?.text || "#999", fontWeight: 600, fontSize: 11 }} />
                  </Stack>
                </Stack>

                <Typography variant="body2" color="text.secondary" sx={{ minHeight: 40, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                  {template.preview_text || "No preview text"}
                </Typography>

                <Stack direction="row" justifyContent="flex-end" spacing={0.5}>
                  <Tooltip title="Edit"><IconButton size="small" onClick={() => onEdit(template)} sx={{ color: accent }}><EditOutlinedIcon fontSize="small" /></IconButton></Tooltip>
                  <Tooltip title="Send"><IconButton size="small" onClick={() => onSend(template)} sx={{ color: "#2e7d32" }}><SendOutlinedIcon fontSize="small" /></IconButton></Tooltip>
                  {!isGlobal && <Tooltip title="Delete"><IconButton size="small" onClick={() => onDelete(template.id)} sx={{ color: "#ef5350" }}><DeleteOutlineIcon fontSize="small" /></IconButton></Tooltip>}
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        </Fade>
      </Grid>
    ));
  };

  return (
    <Stack spacing={3}>
      {/* Filters */}
      <Paper elevation={0} sx={{ p: 2.5, borderRadius: 3, border: "1px solid #e3e8f0" }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={4}>
            <TextField fullWidth size="small" placeholder="Search templates..." value={templateFilter.search}
              onChange={(e) => setTemplateFilter((p) => ({ ...p, search: e.target.value }))} sx={inputSx}
              InputProps={{ startAdornment: <SearchOutlinedIcon sx={{ mr: 1, color: "#999", fontSize: 20 }} /> }} />
          </Grid>
          <Grid item xs={6} sm={3}>
            <TextField select fullWidth size="small" label="Type" value={templateFilter.type}
              onChange={(e) => setTemplateFilter((p) => ({ ...p, type: e.target.value }))} sx={inputSx}>
              <MenuItem value="">All Types</MenuItem>
              {TEMPLATE_TYPES.map((t) => <MenuItem key={t} value={t}>{t}</MenuItem>)}
            </TextField>
          </Grid>
          <Grid item xs={6} sm={3}>
            <TextField select fullWidth size="small" label="Status" value={templateFilter.status}
              onChange={(e) => setTemplateFilter((p) => ({ ...p, status: e.target.value }))} sx={inputSx}>
              <MenuItem value="">All Status</MenuItem>
              {TEMPLATE_STATUS.map((s) => <MenuItem key={s} value={s}>{s}</MenuItem>)}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Button fullWidth variant="outlined" size="small" onClick={() => setTemplateFilter({ search: "", type: "", status: "" })}
              sx={{ borderColor: accent, color: accent, borderRadius: "10px", textTransform: "none", fontWeight: 600 }}>Clear</Button>
          </Grid>
        </Grid>
      </Paper>

      {/* Private */}
      <Box>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
          <LockOutlinedIcon sx={{ color: accent, fontSize: 20 }} />
          <Typography variant="h6" fontWeight={700} sx={{ color: "#1a1a2e" }}>Your Templates</Typography>
          <Chip size="small" label={privateTemplates.length} sx={{ backgroundColor: accentLight, color: accent, fontWeight: 700 }} />
        </Stack>
        <Grid container spacing={2}>{renderCards(privateTemplates, false)}</Grid>
      </Box>

      {/* Global */}
      <Box>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
          <PublicOutlinedIcon sx={{ color: accent, fontSize: 20 }} />
          <Typography variant="h6" fontWeight={700} sx={{ color: "#1a1a2e" }}>Global Templates</Typography>
          <Chip size="small" label={globalTemplates.length} sx={{ backgroundColor: accentLight, color: accent, fontWeight: 700 }} />
        </Stack>
        <Grid container spacing={2}>{renderCards(globalTemplates, true)}</Grid>
      </Box>
    </Stack>
  );
};

export default EmailTemplatesTab;
